import { render, staticRenderFns } from "./ConfigurationLicenseLimiterCard.vue?vue&type=template&id=00957f40"
import script from "./ConfigurationLicenseLimiterCard.vue?vue&type=script&lang=js"
export * from "./ConfigurationLicenseLimiterCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports